import { ProductType } from '@/api/ProductTypeApi';
import { UUID } from './types';
import { ProductTypeVariant } from '@/api/ProductTypeVariantApi';
import { AttributeValue } from '@/api/AttributeValueApi';
import { Attribute } from '@/api/AttributeApi';

export enum CreatorStep {
	PRODUCT_TYPES = 'PRODUCT_TYPES',
	SUMMARY = 'SUMMARY',
}

export type CreatorAttributeValue = AttributeValue & {
	enabled: boolean;
};

export type CreatorAttribute = Attribute & {
	attributeValues: CreatorAttributeValue[];
};

export interface CreatorInfoModalData {
	title: string;
	description: string;
	imagePath?: string;
}

export interface CreatorOptions {
	currentStep: CreatorStep | UUID;
	isLoading: boolean;
	infoModalOpened: boolean;
	infoModalData: CreatorInfoModalData;
}

export interface CreatorState {
	selectedProductType: ProductType | null;
	selectedProductTypeVariants: ProductTypeVariant[];
	availableProductTypeVariants: ProductTypeVariant[];
	creatorAttributes: CreatorAttribute[];
	selectedAttributeValues: Record<UUID, AttributeValue | null>[];
	optionalProductComponents: Record<UUID, number>;
	quantity: number;
	price: number;
	options: CreatorOptions;
}

export type SerializedProject = {};
